<template>
    <section>
      <transition name="fade">
        <div class="bloco-animacao-redirecionar-usuario">
          <h1><BreedingRhombusSpinner/></h1>
        </div>
      </transition>
    </section>
</template>

<script>
import { BreedingRhombusSpinner } from 'epic-spinners'

export default {
  data () {
    return {
      env: process.env
    }
  },
  components: {
    BreedingRhombusSpinner
  },
  mounted () {
    this.autenticaComSSP()
  },
  methods: {
    autenticaComSSP: function () {
      let vm = this
      vm.$axios.post(`${vm.env.AUTENTICA}/autenticarComTokenTemporario`, {
        hash: vm.$route.query.hash
      })
      .then(function (response) {
        localStorage.setItem('sessaoUsuario', JSON.stringify(response.data))
        window.location.href = '/'
        // vm.$router.push('/')
      }).catch(function (error) {
        vm.$store.commit('setAlert', {msg: 'Não foi possível autenticar', status: false, show: true})
        console.log(error)
        window.location.href = vm.env.ADMINISTRATIVO
      })
    }
  }
}
</script>
<style scoped>
  .bloco-animacao-redirecionar-usuario {
    color: #FFF;
    position: fixed;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    background-color: #222d32;
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 1s;
    text-align: center;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity 2s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// LoginTokenTemporario.vue?2977e0bf